import { X } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils.ts";
import { usePopupStore } from "@/lib/hooks/conversations/use-popup-store.ts";

export type EscalationPopupPlacement = "above-fab" | "below-header";

interface EscalationPopupProps {
  onClose: () => void;
  isOpen: boolean;
  position: "left" | "right";
  /** above-fab = legacy FAB anchor; below-header = new Attention 3-dot menu. */
  placement?: EscalationPopupPlacement;
  children: React.ReactNode;
  title: string;
  height?: string;
  width?: string;
}

export const EscalationPopup = ({
  onClose,
  isOpen,
  position,
  placement = "above-fab",
  children,
  title,
  height = "640px",
  width = "500px",
}: EscalationPopupProps) => {
  const { setEscalationPopupOpen } = usePopupStore();

  const handleClose = () => {
    onClose();
    setEscalationPopupOpen(false);
  };

  return (
    <Card
      id="escalation-popup"
      className={cn(
        "popup-escalation shadow-lg",
        placement === "above-fab" && "absolute bottom-16",
        placement === "above-fab" && (position === "left" ? "left-0" : "right-0"),
        placement === "below-header" && "relative max-h-[min(580px,calc(100vh-7rem))]",
        !isOpen && "hidden",
      )}
      style={{ width }}
    >
      <div className="flex items-center justify-between border-b p-4">
        <h2 className="text-lg font-semibold">{title}</h2>
        <button
          onClick={handleClose}
          className="rounded-full p-1 hover:bg-gray-100"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <div
        className="overflow-y-auto p-4"
        style={{
          height:
            placement === "below-header"
              ? undefined
              : height,
          maxHeight:
            placement === "below-header"
              ? "min(520px, calc(100vh - 9rem))"
              : undefined,
        }}
      >
        {children}
      </div>
    </Card>
  );
};
